import NewFeaturesData from "assets/files/NewFeatures.json"

export function GetNewFeaturesData() {
    return NewFeaturesData;
}